import { render, staticRenderFns } from "./admincenter.vue?vue&type=template&id=08c64feb&"
import script from "./admincenter.vue?vue&type=script&lang=js&"
export * from "./admincenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports